import * as ActionTypes from './types';
import { actionCreator } from '../helpers/actionCreator';

export const redirectToViewTerms = actionCreator(ActionTypes.REDIRECT_TO_VIEW_TERMS);
